var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleSmall = function SvgCircleSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2ZM6.0005 3.52344C4.63293 3.52344 3.52431 4.63207 3.52431 5.99963C3.52431 7.36719 4.63293 8.47582 6.0005 8.47582C7.36806 8.47582 8.47669 7.36719 8.47669 5.99963C8.47669 4.63207 7.36806 3.52344 6.0005 3.52344Z",
    fill: "url(#paint0_linear_10008_146811)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10008_146811",
    x1: 2.19048,
    y1: 2.19048,
    x2: 10,
    y2: 10.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44B50C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EFF00"
  })))));
};
export default SvgCircleSmall;